import { useState, useContext, useEffect } from "react";
import dataApplicationsContext from "../context/dataApplicationsContext";
import { Link, useMatch, useResolvedPath, useNavigate, useLocation } from "react-router-dom";
import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import { useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";

export default function Hamburger({  }) {
  const { windowWidth, isMenuActive, setIsMenuActive, setIsSearchOpen, setIsSearch, setSearchCompet, setSearchParticipant, setIsConnected, 
          auth, setAuth, setDisplayResult, setDisplayResultLabel, isScrollingDown } = useContext(dataApplicationsContext);
  
  const location = useLocation();
  const navigate = useNavigate();
  const [sendLogout, { isLoadind, isSuccess, isError, error }] = useSendLogoutMutation();

  const handleNavigate = (e, link, force) => {
    e.preventDefault();
    navigate(link)
    setIsMenuActive(false);
    if (window.scrollY) {
      window.scroll(0, 0);  // reset the scroll position to the top left of the document.
    }
  }

  const firstCustomAnimation = keyframes`
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  `;

  const secondCustomAnimation = keyframes`
    from {
      opacity: 0;
      transform: translateX(30px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  `;

  const activeLink = (link) => {
    return location.pathname === link ? 'link-active' : ''
  }

  const handleLogout = () => {
    sendLogout();
    window.scrollTo({ top: 0, left: 0 })
    setAuth([]);
    secureLocalStorage.removeItem('jwt');
    secureLocalStorage.removeItem('account-session');
    setIsConnected(false);
    setIsMenuActive(false);
    navigate('/');
  }

 const hamburger = 
  <>
    <div className={`menu-container ${(isScrollingDown) ? 'hide' : ''} ${location.pathname === '/app/dashboard' ? 'menu-container-admin' : ''}`} id={isMenuActive ? 'menu-container-open' : ''}>
      <div className={`primary-links-container`}>
        <Reveal keyframes={firstCustomAnimation} cascade={true} duration={200} damping={0.5}>
          <div className={`menu-link ${activeLink('/')}`} onClick={(e) => handleNavigate(e, '/')}>Home</div>
          <div className={`menu-link ${activeLink('/effectifs')}`} onClick={(e) => handleNavigate(e, '/effectifs')}>Effectifs</div>
          <div className={`menu-link ${activeLink('/presence')}`} onClick={(e) => handleNavigate(e, '/presence')}>Présences</div>
          <div className={`menu-link ${activeLink('/generale-presence')}`} onClick={(e) => handleNavigate(e, '/generale-presence')}>Vue Générale</div>
          {/* <div className={`menu-link ${activeLink('/droit-image')}`} onClick={(e) => handleNavigate(e, '/droit-image')}>Droit à l'image</div>
          <div className={`menu-link ${activeLink('/allergies')}`} onClick={(e) => handleNavigate(e, '/allergies')}>Allergies</div> */}
          {auth?.user?.first_name && <div className={`menu-link menu-logout`} onClick={handleLogout}>Se déconnecter</div>}
        </Reveal >
      </div>
    </div>
  </>

  return (
    hamburger
  )
}
